import React, {Fragment} from "react";
import Button from "../Button";
import ChangePurchaseItem from "../../editors/OperationList/Elements/ChangePurchaseItem";

export default class SwapPayment extends React.Component {
    render() {
        const purchaseitems = (this.props.option || {}).purchaseitems || [];
        return (
            <div className="payment swap-payment">
                <Button
                    color="default"
                    block={true}
                    onClick={() => {
                        this.cpi && this.cpi.focus();
                    }}>
                        {
                            purchaseitems.length ?
                                <Fragment>
                                    {purchaseitems.length} tétel / {purchaseitems.map((item) => item.qty).reduce((acc, n) => parseFloat(acc || "0") + parseFloat(n || "0"))}
                                    darab kiválasztva
                                </Fragment>
                                :
                                <Fragment>
                                    Kiválasztás
                                </Fragment>
                        }
                    </Button>
                <ChangePurchaseItem
                    ref={(cpi) => this.cpi = cpi}
                    selection={purchaseitems}
                    setSelected={(items) => {
                        this.props.setFieldValue(String(this.props.optionIndex) + ".purchaseitems", items);
                        this.props.setFieldValue(String(this.props.optionIndex) + ".amount", items.length ? items.map((item) => parseFloat(item.qty) * parseFloat(item.saleprice)).reduce((sum, price) => parseFloat(sum || "0") + parseFloat(price || "0")) : 0);
                    }}
                />
            </div>
        );
    }
}